import { Box, IconButton, Link, VStack, Text } from '@chakra-ui/react'
import React from 'react'
import { FaFacebook } from 'react-icons/fa'
import { IContactInfo, IFooterLink } from './types'

export const ContactInfo: React.FC<IContactInfo> = ({ companyName, address, phone }) => (
  <VStack alignItems='flex-start' spacing='3px'>
    <Text 
      fontWeight='bold'
      color='var(--color-brand)'
    >
      {companyName}
    </Text>
    <Text>
      {address}
    </Text>
    <Link 
      href={`tel:${phone}`} 
      color='var(--color-brand)' 
      textDecoration='underline'
    >
      {phone}
    </Link>
  </VStack>
)

export const FooterLinks: React.FC<{ links: IFooterLink[] }> = ({ links }) => (
  <VStack alignItems='flex-start' spacing='3px'>
    {links.map((link, index) => (
      <Link key={index} href={link.link} target={link.target} display='block'>
        {link.label}
      </Link>
    ))}
  </VStack>
)

export const FacebookLink: React.FC<{ link: string }> = ({ link }) => (
  <Box textAlign='right'>
    <IconButton
      as='a'
      href={link}
      target='_blank'
      aria-label='Facebook Page'
      icon={<FaFacebook />}
      backgroundColor='var(--color-brand)'
      color='white'
    />
  </Box>
)
